import { PREDEFINED_QUERIES } from '@app/config/media-queries';
import styled from 'styled-components';

export const Content = styled.div`
  padding: 20px;
  background-color: #ffffff;
  border-radius: 0 0 5px 5px;
  height: 100%;

  @media screen and (${PREDEFINED_QUERIES.isTabletOrLess}) {
    padding: 0px;
  }
`;
